document.addEventListener("DOMContentLoaded", function (event) {
  event.preventDefault()
  var productBlocks = document.querySelectorAll(".product-block");
  productBlocks.forEach(function (productBlock) {
    if (
      productBlock.querySelector(".product__quantity") &&
      !productBlock.classList.contains("hide")
    ) {
      var qtyButton = productBlock;
    }
    if (qtyButton) {
      var buyButton = qtyButton.nextElementSibling;
      if (
        !buyButton ||
        !buyButton.classList.contains("bss-custom-buy-button")
      ) {
        buyButton = qtyButton.previousElementSibling;
      }
      if (buyButton && buyButton.classList.contains("bss-custom-buy-button")) {
        qtyButton.classList.add("bss-custom-qty");
        buyButton.classList.add("active");
      }
    }
  });
});
